import formatPrefixAuto from'./format-prefix-auto';import formatRounded from'./format-rounded';export default{"%":(a,b)=>(100*a).toFixed(b),b:a=>Math.round(a).toString(2),c:a=>a+'',d:a=>Math.round(a).toString(10),e:(a,b)=>a.toExponential(b),f:(a,b)=>a.toFixed(b),g:(a,b)=>a.toPrecision(b),o:a=>Math.round(a).toString(8),p:(a,b)=>formatRounded(100*a,b),r:formatRounded,s:formatPrefixAuto,X:a=>Math.round(a).toString(16).toUpperCase(),x:a=>Math.round(a).toString(16)};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-utils/src/number-converter/format-types.js
// module id = null
// module chunks = 